// import { useUserStore } from "@/modules/auth/store/auth-store";

// const { userData } = useUserStore.getState();


// const accessToken = localStorage.getItem("authToken") ? localStorage.getItem("authToken") : userData.accessToken 

export const basicAuthHeader = () => ({
  "Content-Type": "application/json",
  platform: "WEB",
  api_key: "1234",
  language: "en",
  timezone: "5",
  Authorization: "Basic aW5mb3Byb2ZpbGU6aW5mb3Byb2ZpbGVAMTIz",
});

export const bearerAuthHeader = (token) => ({
  "Content-Type": "application/json",
  platform: "WEB",
  api_key: "1234",
  language: "en",
  timezone: "5",
  Authorization: `Bearer ${token}`,
});
